import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { resumePendingLocalDataClear } from './features/auth/services/local-data'

// Before anything renders, so before anything opens a database: a log out that
// left for SecureID before its IndexedDB deletes landed finishes them here.
void resumePendingLocalDataClear()

createRoot(document.getElementById('root')!).render(<App />)
